import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function useAuthFetch() {
  const { token, logout } = useAuth();

  const fetchWithAuth = useCallback(async (url, options = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
      logout();
      throw new Error('Session expirée');
    }

    return response;
  }, [token, logout]);

  return fetchWithAuth;
}
